import React from "react";
import styled from "styled-components";

export const SnackBarClose: React.FC<{ onClick: () => void }> = (props: {
  onClick: () => void;
}) => {
  const { onClick } = props;

  return (
    <Svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <path
        d="M11.5,10.156l7.878-7.878a.95.95,0,0,1,1.344,1.344L12.844,11.5l7.878,7.878a.95.95,0,0,1-1.344,1.344L11.5,12.844,3.622,20.722a.95.95,0,0,1-1.344-1.344L10.156,11.5,2.278,3.622A.95.95,0,0,1,3.622,2.278Z"
        transform="translate(-2 -2)"
        fill="#333"
        fillRule="evenodd"
      />
    </Svg>
  );
};

const Svg = styled.svg``;
